<template>
  <div class="main_style">
    <navbar />
    <p class="font-title mx-5 px-5">รายการสำรวจ</p>
    <div
      v-if="this.user.user.group_id < 5"
      class="mx-auto text-center"
      style="width: 50%"
    >
      <b-row>
        <b-col class="my-3 mx-auto" cols="12" offset-xl="3">
          <multiselect
            id="community"
            v-model="community_selected"
            :close-on-select="true"
            :initialValues="community_selected"
            :options="this.communityOption"
            class="multiselect-style2 custom-multiselect text-left"
            deselect-label="ยกเลิก"
            label="name"
            placeholder="ชุมชน"
            select-label=""
            selectedLabel=""
            track-by="id"
            @input="getResult"
          ></multiselect>
        </b-col>
      </b-row>
    </div>
    <b-row class="text-center my-2 mx-auto justify-content-center">
      <template v-if="this.user.user.community_id">
        <b-col cols="6" lg="4" md="4" sm="4" xl="2">
          <b-btn
            class="btn-form btn-green"
            style="color: #41634a"
            @click="gotoForm()"
          >
            <b-icon class="my-1" icon="plus-circle-fill"></b-icon>
            เพิ่มข้อมูล
          </b-btn>
        </b-col>
        <b-col cols="6" lg="4" md="4" sm="4" xl="2">
          <b-btn
            class="btn-form btn-orange"
            style="color: #db7f50"
            @click="chooseFiles()"
          >
            <b-icon class="my-1" icon="plus-circle-fill"></b-icon>
            เพิ่มข้อมูล Excel
          </b-btn>
          <input
            id="fileUpload"
            accept=".xlsx, .xls"
            hidden
            style="display: none !important"
            type="file"
            @change="uploadExcel($event)"
          />
        </b-col>
        <b-col cols="6" lg="4" md="4" sm="4" xl="2">
          <b-btn
            class="btn-form btn-orange"
            style="color: #db7f50"
            @click="chooseImage()"
          >
            <b-icon class="my-1" icon="plus-circle-fill"></b-icon>
            เพิ่มรูปภาพ
          </b-btn>
          <input
            id="imageUpload"
            accept="image/*"
            hidden
            style="display: none !important"
            type="file"
            multiple
            @change="uploadImage($event)"
          />
        </b-col>
      </template>
    </b-row>
    <div>
      <b-row>
        <b-col
          xl="5"
          offset-xl="3"
          lg="6"
          offset-lg="2"
          sm="10"
          offset-sm=" 1"
          class="my-3"
        >
          <b-form-group
            label=""
            label-for="filter-input"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="sm"
            class="mb-0"
          >
            <b-input-group size="md">
              <b-form-input
                id="filter-input"
                v-model="filter"
                type="search"
                placeholder="ค้นหา"
                style="border-radius: 15px"
                class="w-50"
              ></b-form-input>

              <b-input-group-append>
                <button
                  class="mx-0"
                  pill
                  style="
                    background-color: #3b5286;
                    color: white;
                    width: 100%;
                    border-radius: 15px;
                  "
                  :disabled="!filter"
                  @click="filter = ''"
                >
                  ล้างค่า
                </button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="2" style="padding-top: 30px">
          ผลการค้นหา {{ items.length }} รายการ
        </b-col>
      </b-row>

      <b-table
        :filter="filter"
        :fields="fields"
        :items="this.items"
        class="mx-auto"
        hover
        responsive="md"
      >
        <template #cell(select)="row">
          <b-input-group class="d-block text-center">
            <b-checkbox
              @change="checkAvailable(row.item.code)"
              v-model="plant_lists"
              :value="row.item"
            >
            </b-checkbox>
          </b-input-group>
        </template>
        <template #cell(no)="row">
          {{ row.index + 1 }}
        </template>
        <template #cell(code)="row">
          <a
            class="text-orange"
            style="color: black"
            @click="openEditSurveyForm(row.item.code)"
            >{{ row.item.code }}</a
          >
        </template>
        <template #cell(action)="row">
          <a
            class="text-orange pointer"
            style="color: black; font-weight: 900"
            @click="openEditSurveyForm(row.item.code)"
          >
            เปิด
          </a>
        </template>
      </b-table>

      <b-row class="text-center my-4 justify-content-center">
        <b-col cols="12" lg="3" md="4" sm="4" xl="3">
          <b-btn
            class="btn-form"
            style="color: white; background-color: #828282"
            @click="saveToBank"
          >
            บันทึกข้อมูลลงแปลงธนาคาร
          </b-btn>
        </b-col>
        <b-col cols="12" lg="3" md="4" sm="4" xl="3">
          <b-btn class="btn btn-danger" @click="deleteData"> ลบข้อมูล </b-btn>
        </b-col>
      </b-row>
    </div>
    <b-modal
      id="upload-image-result"
      centered
      title="ผลการเพิ่มรูป"
      hide-footer
    >
      <b-table :fields="uploadImageResultfields" hover :items="imageResult">
        <template #cell(name)="row">
          {{ row.item.name }}
        </template>
        <template #cell(isSuccess)="row">
          <template v-if="row.item.isSuccess"
            ><div class="text-success">สำเร็จ</div>
          </template>
          <template v-else><div class="text-danger">ไม่สำเร็จ</div> </template>
        </template>
        <template #cell(message)="row">
          {{ row.item.message }}
        </template>
      </b-table>
    </b-modal>
  </div>
</template>

<script>
import navbar from "@/components/navbar";
import { mapState } from "vuex";
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";
import axios from "axios";
import { domain } from "@/utils/Constants";
import moment from "moment";

export default {
  name: "Survey",
  data() {
    return {
      searchValue: "",
      community_selected: [],
      communityOption: [],
      plant_lists: [],
      items: [],
      imageResult: [],
      uploadImageResultfields: [
        { key: "name", label: "ชื่อ" },
        { key: "isSuccess", label: "สถานะ" },
        { key: "message", label: "ข้อความ" },
      ],
      fields: [
        { key: "select", label: "เลือก" },
        { key: "no", label: "ลำดับ", sortable: true },
        { key: "code", label: "รหัสข้อมูล", sortable: true },
        { key: "name_bio", label: "ชื่อพืช", sortable: true },
        { key: "name_plant", label: "ชื่อแปลงสำรวจ", sortable: true },
        { key: "type_plant", label: "ประเภทแปลง", sortable: true },
        { key: "community", label: "ชื่อชุมชน", sortable: true },
        { key: "date", label: "วันที่ลงข้อมูล", sortable: true },
        { key: "survey_date", label: "วันที่สำรวจ", sortable: true },
        { key: "bank_date", label: "วันที่จัดเก็บแปลงธนาคาร", sortable: true },
        { key: "status", label: "สถานะ", sortable: true },
        { key: "action", label: "เปิดดู" },
      ],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      file: null,
    };
  },
  watch: {
    plants_bank(newCount, oldCount) {
      this.generateTable();
    },
  },
  components: { navbar, Multiselect },
  created() {
    this.prepareData();
  },
  computed: {
    ...mapState({
      plants_survey: (state) => state.plantsModule.plants_survey,
      plants_bank: (state) => state.plantsModule.plants_bank,
      list_save: (state) => state.plantsModule.list_save,
      community: (state) => state.OptionsModule.community,
      user: (state) => state.AuthModule.userData,
      accessToken: (state) => state.AuthModule.accessToken,
      form: (state) => state.formSurveyModule.form,
    }),
  },
  methods: {
    searchPlant() {
      let data = {
        data: this.searchValue,
        user: this.user,
        token: this.accessToken,
      };
      Swal.fire({
        title: "ระบบกำลังทำงาน",
        html: "โปรดรอสักครู่...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
          this.$store.dispatch("plantsModule/onSearchPlants", data).then(() => {
            this.items = [];
            this.generateTable();
          });
        },
      });
    },
    prepareData() {
      this.$store.dispatch("formSurveyModule/clearForm");
      if (this.user.user.group_id == 5) {
        Swal.fire({
          title: "ระบบกำลังทำงาน",
          html: "โปรดรอสักครู่...",
          allowEscapeKey: false,
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
            let data = {
              type: 0,
              community_id: this.user.user.community_id,
              token: this.accessToken,
            };
            this.$store.dispatch("plantsModule/getAllPlants", data).then(() => {
              this.generateTable();
            });
          },
        });
      } else {
        this.user.user.community_id = null;
        //user role admin,Webmaster
        let data = 0;
        Swal.fire({
          title: "ระบบกำลังทำงาน",
          html: "โปรดรอสักครู่...",
          allowEscapeKey: false,
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
            this.$store
              .dispatch("OptionsModule/onGetCommunityOption", data)
              .then(() => {
                if (this.community.length) {
                  this.communityOption.push({
                    id: 0,
                    name: "ทุกชมชน",
                  });
                  this.community.forEach((item) => {
                    this.communityOption.push({
                      id: item.community_id,
                      name: item.name,
                    });
                  });
                }
              })
              .then(() => {
                Swal.clickConfirm();
              });
          },
        });
      }
    },
    getResult() {
      if (this.community_selected.id || this.community_selected.id == 0) {
        this.user.user.community_id = this.community_selected.id;
        let data = {
          type: 0,
          community_id: this.user.user.community_id,
          token: this.accessToken,
        };
        setTimeout(() => {
          console.log("data", data);
          Swal.fire({
            title: "ระบบกำลังทำงาน",
            html: "โปรดรอสักครู่...",
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
              this.$store
                .dispatch("plantsModule/getAllPlants", data)
                .then(() => {
                  this.items = [];
                  this.generateTable();
                });
            },
          });
        }, 500);
      }
    },
    gotoForm() {
      this.$store.dispatch("formSurveyModule/clearForm").then(() => {
        this.$router.push("/Form");
      });
    },
    openEditSurveyForm(code) {
      // this.$router.push(`/Form?code=${code}`);
      this.$store.dispatch("formSurveyModule/getForm", code).then((res) => {
        if (res.code == 200) {
          this.$router.push("/Form");
        } else {
          Swal.fire({
            icon: "error",
            title: "ผิดพลาด!",
            text: "ไม่พบข้อมูล",
          });
        }
      });
    },
    generateTable() {
      this.plant_lists = [];
      this.items = [];
      if (this.plants_survey.length > 0) {
        this.plants_survey.forEach((item) => {
          let data = {
            // select:
            //   '</b-input-group><b-checkbox :value=`${item.id}` v-model="plant_lists"></b-checkbox></<b-input-group>',
            code: item.plants.plant_code,
            name_bio: item.plants.bio_name,
            name_plant: item.survey_plot_name,
            type_plant: "แปลงสำรวจ",
            community: item.plants.community,
            date: moment(item.plants.created_at).format(moment.HTML5_FMT.DATE),
            survey_date: item.survey_date,
            bank_date: null,
            status: item.plants.status,
          };
          this.items.push(data);
        });
      }
      if (this.plants_bank.length > 0) {
        this.plants_bank.forEach((item) => {
          let data = {
            // select: "",
            code: item.plants.plant_code,
            name_bio: item.plants.bio_name,
            name_plant: item.bank_plot_name,
            type_plant: "แปลงสำรวจ,แปลงธนาคาร",
            community: item.plants.community,
            date: moment(item.plants.created_at).format(moment.HTML5_FMT.DATE),
            survey_date: item.survey.survey_date,
            bank_date: item.bank_date,
            status: item.plants.status,
          };
          this.items.push(data);
        });
      }
      Swal.clickConfirm();
    },
    saveToBank() {
      let filter = this.dataFilter(this.plant_lists);
      if (filter.length > 0) {
        this.$store.dispatch("plantsModule/saveListBank", filter);
        this.$router.push("/saveBank");
      } else {
        Swal.fire({
          icon: "error",
          title:
            "โปรดเลือกรายการ หรือ เพิ่มข้อมูลเข้าแปลงธนาคารได้เฉพาะแปลงสำรวจเท่านั้น",
        });
      }
    },
    deleteData() {
      let filter = this.dataFilterForDelete(this.plant_lists);
      if (filter.length > 0) {
        let data = {
          plants: filter,
          token: this.accessToken,
        };
        Swal.fire({
          title: "ต้องการลบข้อมูล?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "ตกลง",
          cancelButtonText: "ยกเลิก",
        }).then((result) => {
          if (result.isConfirmed) {
            Swal.fire({
              title: "ระบบกำลังทำงาน",
              html: "โปรดรอสักครู่...",
              allowEscapeKey: false,
              allowOutsideClick: false,
              didOpen: () => {
                Swal.showLoading();
                this.$store
                  .dispatch("plantsModule/onDeleteBulkplant", data)
                  .then((res) => {
                    if (res.code == 200) {
                      Swal.fire({
                        icon: "success",
                        title: "ลบสำเร็จ",
                      });
                      this.getResult();
                    } else {
                      Swal.fire({
                        icon: "error",
                        title: "ผิดพลาด!",
                      });
                    }
                  });
              },
            });
          }
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "โปรดเลือกข้อมูลในการลบ",
        });
      }
    },
    dataFilter(data) {
      let filter = [];
      data.forEach((item) => {
        if (item.type_plant === "แปลงสำรวจ") {
          filter.push(
            this.plants_survey.filter((items) => {
              return items.plants.plant_code == item.code;
            })
          );
        } else {
          return (filter = []);
        }
      });
      return filter;
    },
    dataFilterForDelete(data) {
      let filter = [];
      data.forEach((item) => {
        let model = null;
        if (item.type_plant === "แปลงสำรวจ") {
          model = this.plants_survey.find((items) => {
            return items.plants.plant_code == item.code;
          });
        } else {
          model = this.plants_bank.find((items) => {
            return items.plants.plant_code == item.code;
          });
        }
        if (model) filter.push(model);
      });
      return filter;
    },
    chooseFiles() {
      document.getElementById("fileUpload").click();
    }, //imageUpload
    chooseImage() {
      document.getElementById("imageUpload").click();
    },
    uploadImage(event) {
      if (event.target.files.length > 0) {
        Swal.fire({
          title: "ระบบกำลังทำงาน",
          html: "โปรดรอสักครู่...",
          allowEscapeKey: false,
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
            let input = event.target;
            let formData = new FormData();
            input.files.forEach((file, index) => {
              formData.append(`image${index}`, file);
            });
            formData.append("imageLength", input.files.length);
            formData.append("user_id", this.user.user.id);
            formData.append("user_comunity", this.user.user.community_id);
            axios({
              method: "post",
              url: domain + "/api/uploadImageViaExcel",
              data: formData,
              headers: { "Content-Type": "multipart/form-data" },
            }).then((res) => {
              if (res.data.code === 200) {
                Swal.clickConfirm();
                this.imageResult = res.data.result;
                this.$bvModal.show("upload-image-result");
              } else {
                Swal.fire({
                  icon: "error",
                  title: "อัพโหลดรูปไม่สำเร็จ",
                });
              }
            });
          },
        });
      }
    },
    uploadExcel() {
      let file = event.target.files ? event.target.files[0] : null;
      let formData = new FormData();
      formData.append("file", file);
      formData.append("user_id", this.user.user.id);
      formData.append("user_comunity", this.user.user.community_id);
      Swal.fire({
        title: "ระบบกำลังทำงาน",
        html: "โปรดรอสักครู่...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch("formSurveyModule/onImportExcel", formData)
            .then((res) => {
              if (res == "สำเร็จ") {
                let data = {
                  type: 0,
                  community_id: this.user.user.community_id,
                  token: this.accessToken,
                };
                this.$store
                  .dispatch("plantsModule/getAllPlants", data)
                  .then(() => {
                    this.generateTable();
                  });
              } else {
                Swal.fire({
                  icon: "error",
                  title: res,
                });
              }
            });
        },
      });
    },
    getAllData() {
      let data = {
        type: 0,
        community_id: 0,
        token: this.accessToken,
      };
      Swal.fire({
        title: "ระบบกำลังทำงาน",
        html: "โปรดรอสักครู่...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
          this.$store.dispatch("plantsModule/getAllPlants", data).then(() => {
            this.generateTable();
          });
        },
      });
    },
    checkAvailable(code) {
      if (this.plants_survey.length > 0) {
        let filter = this.plants_survey.filter((item) => {
          return item.plants.plant_code == code;
        });
        if (filter.length > 0) {
          var plant_id = filter[0].plant_id;
          let data = {
            plant_id: plant_id,
            user: this.user.user,
            token: this.accessToken,
          };
          this.$store
            .dispatch("plantsModule/onCheckAvailable", data)
            .then((res) => {
              if (res.result.message != "success") {
                Swal.fire(
                  {
                    icon: "error",
                    title: res.result.message,
                  },
                  setTimeout(() => {
                    window.location.reload();
                  }, 500)
                );
              }
            });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
